import React, { useState } from "react";
import styled from "styled-components";
import { FiFileText, FiSave, FiSend } from "react-icons/fi";
import { useDispatch } from "react-redux";
import { updateBooking } from "../../redux/actions/mindfulness";
import { handleSuccessMessage } from "../../redux/actions/success";

const ConcludeSession = ({ bookingData, bookingId }) => {
  const [notes, setNotes] = useState("");
  const charCount = notes.length;
  const [isLoading, setIsLoading] = useState(false);
  const handleSaveDraft = () => {
    console.log("Saving draft:", notes);
    // Add your save logic here
  };

  const dispatch = useDispatch();

  const handleConcludeAndSend = async () => {
    let formData = new FormData();

    formData.append("status", "complete");
    formData.append("notes", notes);

    console.log("payload", formData)

    try {
      setIsLoading(true);
      await dispatch(updateBooking(bookingId, formData));
      handleSuccessMessage("Session Concluded Successfully");
      // history.push("/creator_dashboard");
    } catch (error) {
      console.error("Error creating session", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container>
      <Header>
        <TitleSection>
          <h2>Conclude Session</h2>
          <p>Add session notes and recommendations for the student</p>
        </TitleSection>
        <IconWrapper>
          <FiFileText size={24} color="#FF3B3F" />
        </IconWrapper>
      </Header>

      <Divider />

      <Label htmlFor="session-notes">
        Session Notes<span>*</span>
      </Label>
      <Textarea
        id="session-notes"
        value={notes}
        onChange={(e) => setNotes(e.target.value)}
        placeholder="Describe what was discussed during the session, student's concerns, progress made..."
      />
      <CharCounter>{charCount} characters</CharCounter>

      <ButtonGroup>
        <SaveDraftButton onClick={handleSaveDraft}>
          <FiSave size={18} />
          Save Draft
        </SaveDraftButton>
        <ConcludeButton onClick={handleConcludeAndSend} disabled={!bookingId}>
          <FiSend size={18} />
          Conclude Session & Send to Student
        </ConcludeButton>
      </ButtonGroup>
    </Container>
  );
};

// --- Styled Components ---

const Container = styled.div`
  width: 100%;
  /* margin: 2rem auto; */
  padding: 2rem;
  background: #fff;
  border-radius: 12px;
  box-sizing: border-box;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  font-weight: 400;
  font-family: Montserrat;

  box-sizing: border-box;
  border: 1.28px solid rgba(229, 231, 235, 1);
  border-radius: 12.78px;
  box-shadow: 0px 1.28px 3.8333334922790527px 0px rgba(0, 0, 0, 0.1),
    0px 1.28px 2.555555582046509px -1.28px rgba(0, 0, 0, 0.1);
  background: rgba(255, 255, 255, 1);
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1.5rem;
`;

const TitleSection = styled.div`
  h2 {
    margin: 0 0 0.5rem 0;
    font-size: 1.5rem;
    font-weight: 500;
    color: #333;
    font-family: Montserrat;
  }

  p {
    margin: 0;
    font-size: 0.95rem;
    color: #666;
  }
`;

const IconWrapper = styled.div`
  /* cursor: pointer; */
  &:hover {
    opacity: 0.8;
  }
`;

const Divider = styled.hr`
  border: none;
  border-top: 1px solid #eee;
  margin: 1.5rem 0;
`;

const Label = styled.label`
  display: block;
  font-size: 0.95rem;
  font-weight: 500;
  color: #444;
  margin-bottom: 0.75rem;

  span {
    color: #ff3b3f;
    margin-left: 2px;
  }
`;

const Textarea = styled.textarea`
  width: 100%;
  min-height: 150px;
  padding: 1rem;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 1rem;
  resize: vertical;
  transition: border-color 0.2s ease;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: #ff3b3f;
    box-shadow: 0 0 0 3px rgba(255, 59, 63, 0.1);
  }

  &::placeholder {
    color: #aaa;
  }
`;

const CharCounter = styled.div`
  font-size: 0.85rem;
  color: #888;
  margin-top: 0.5rem;
  text-align: left;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 2rem;
  flex-wrap: wrap;

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

const BaseButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;

  svg {
    flex-shrink: 0;
  }
`;

const SaveDraftButton = styled(BaseButton)`
  background: #fff;
  color: #333;
  border: 1px solid #ddd;

  &:hover {
    background: #f9f9f9;
    border-color: #ccc;
  }
`;

const ConcludeButton = styled(BaseButton)`
  background: #ff3b3f;
  color: white;
  flex: 1;
  min-width: 250px;

  &:hover {
    background: #e63539;
  }

  &:active {
    transform: scale(0.98);
  }
`;

export default ConcludeSession;
